import logo from '../../img/logo.svg';

export default function Logo({ url }) {
	return (
		<a href={url} className="logo">
			<img src={logo} alt="Milanesi Editore logo" />
		</a>
	);
}